/**
 * Колесо мыши над сфокусированным <input type="number"> меняет значение на шаг:
 * ставка 15 при step=0.01 молча превращается в 14.99, и почасовая выплата
 * подрядчику считается от испорченной цифры (19 × 14.99 = 284.81 вместо 285).
 * В денежных формах (ведомость, курс валют, KPI, бюджеты) это тихая порча
 * введённых данных.
 *
 * Лечим одной глобальной подпиской вместо 107 полей: прокрутка НАД самим
 * сфокусированным числовым полем отменяется, всё остальное скроллится как
 * обычно.
 *
 * Почему отмена события, а не blur (который выглядит проще): снятие фокуса
 * дёргает onBlur-обработчики — на странице плана касаний партнёров это сразу
 * шлёт на сервер недописанное число, — и роняет фокус на <body>, ломая
 * клавиатурную навигацию и контекст скринридера. Плата за отмену: страница не
 * прокручивается, пока курсор стоит ровно над сфокусированным числовым полем.
 */
export function installNumberInputWheelGuard(doc = document) {
    const onWheel = (event) => {
        const el = doc.activeElement
        if (!el || el.tagName !== 'INPUT' || el.type !== 'number') return
        if (event.target !== el) return
        event.preventDefault()
    }
    doc.addEventListener('wheel', onWheel, { passive: false, capture: true })
    return () => doc.removeEventListener('wheel', onWheel, { capture: true })
}
